import { useNavigate } from 'react-router-dom'

import { dashboardPath } from 'components/Routes'
// import goldBarImage from 'images/gold-bar.png'

import { Grid2, TextField } from '@mui/material'
import Button from 'components/Button'
// import ImageWithShadow from 'components/ImageWithShadow'
import DefaultLayout from 'components/layout/DefaultLayout'

import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'
import { useAuth } from 'components/AuthProvider'
import { useFormik } from 'formik'
import { useMutateRedeemVoucher } from 'hooks/useVouchers'
import * as Yup from 'yup'

const useStyles = makeStyles()((theme: Theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(2)
  }
}))

const validationSchema = Yup.object().shape({
  redemptionCode: Yup.string().required('Redemption code is required')
})

interface FormValues {
  redemptionCode: string
}

const initialValues: FormValues = {
  redemptionCode: ''
}

export default function RedeemVoucher(): JSX.Element {
  const { classes } = useStyles()
  const navigate = useNavigate()

  const { setToast } = useAuth()

  const { mutate: redeemVoucher, isLoading: redeemVoucherLoading } =
    useMutateRedeemVoucher()

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values: FormValues) => {
      redeemVoucher(values.redemptionCode, {
        onSuccess: () => {
          setToast({
            open: true,
            message: 'Good as gold! Gift redeemed.',
            type: 'success',
            duration: 3000
          })
          navigate(dashboardPath())
        },
        onError: (error: unknown) => {
          const message =
            error instanceof Error ? error.message : 'An error occurred'
          setErrors({ redemptionCode: message })
        }
      })
    }
  })

  const { handleSubmit, setErrors, errors, handleChange, handleBlur } = formik

  return (
    <DefaultLayout heading='Redeem Gift' showBackIcon>
      <form className={classes.form} noValidate onSubmit={handleSubmit}>
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 12 }}>
            <TextField
              autoFocus
              fullWidth
              id='redemptionCode'
              label='Redemption code'
              name='redemptionCode'
              required
              type='text'
              error={!!errors.redemptionCode}
              helperText={errors.redemptionCode}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </Grid2>
          <Grid2 sx={{ textAlign: 'center' }} size={{ xs: 12 }}>
            <Button
              color='primary'
              fullWidth
              variant='outlined'
              disabled={redeemVoucherLoading}
              type='submit'
            >
              Redeem
            </Button>
          </Grid2>
        </Grid2>
      </form>
    </DefaultLayout>
  )
}
